"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Observable_1 = require("./Observable");

function multiplex(inner) {
  var observers = new Set();
  var sub = null;
  return new Observable_1.Observable(function (observer) {
    observers.add(observer);
    sub = sub || inner.subscribe({
      next: function next(value) {
        observers.forEach(function (obs) {
          return obs.next && obs.next(value);
        });
      },
      error: function error(_error) {
        observers.forEach(function (obs) {
          return obs.error && obs.error(_error);
        });
      },
      complete: function complete() {
        observers.forEach(function (obs) {
          return obs.complete && obs.complete();
        });
      }
    });
    return function () {
      if (observers.delete(observer) && !observers.size && sub) {
        sub.unsubscribe();
        sub = null;
      }
    };
  });
}

exports.multiplex = multiplex;

function asyncMap(observable, mapFn) {
  return new Observable_1.Observable(function (observer) {
    var _next = observer.next,
        _error2 = observer.error,
        _complete = observer.complete;
    var activeNextCount = 0;
    var completed = false;
    var handler = {
      next: function next(value) {
        ++activeNextCount;
        new Promise(function (resolve) {
          resolve(mapFn(value));
        }).then(function (result) {
          --activeNextCount;
          _next && _next.call(observer, result);
          completed && handler.complete();
        }, function (e) {
          --activeNextCount;
          _error2 && _error2.call(observer, e);
        });
      },
      error: function error(e) {
        _error2 && _error2.call(observer, e);
      },
      complete: function complete() {
        completed = true;

        if (!activeNextCount) {
          _complete && _complete.call(observer);
        }
      }
    };
    var sub = observable.subscribe(handler);
    return function () {
      return sub.unsubscribe();
    };
  });
}

exports.asyncMap = asyncMap;